import { CustomerModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';

export class RemoteDepositCustomer extends DomainEntity<CustomerModelDto> {
    public get firstName() {
        return this.dto.firstName;
    }

    public get lastName() {
        return this.dto.lastName;
    }

    public get customerReference() {
        return this.dto.customerReference;
    }

    public createDefault(): this {
        return new RemoteDepositCustomer({}) as this;
    }
}
